<template>
    <div>
        <v-row class="d-flex">
            <v-col>
                <v-subheader>Verleden</v-subheader>
            </v-col>
            <v-col class="text-end">
                <v-btn color="secondary" outlined :to="'/phone-call?user_id='+currentUser.id">
                    Alles
                </v-btn>
            </v-col>
        </v-row>

        <v-progress-linear indeterminate color="primary" v-if="loading" />

        <v-list two-line>
            <template v-for="call in historyItems">
                <Row :call="call" @selectedPhonenumber="selectedPhonenumber" :key="call.id" />
                <v-divider :key="'divider' + call.id"></v-divider>
            </template>
        </v-list>
    </div>
</template>

<script>
import PhoneCall from "@/models/PhoneCall/PhoneCall";
import Row from '@/components/PhoneCall/Dialer/History/Row';
import User from "@/models/User/User";

export default {
    components: {
        Row
    },
    data() {
        return {
            loading: true,
            historyItems: [],
        }
    },
    sockets: {
        'phone-call:created'() {
            this.getHistory();
        }
    },
    methods: {
        selectedPhonenumber(number) {
            this.$emit('call', number);
        },
        getHistory() {
            this.loading = true;

            PhoneCall
                .api()
                .filtered({
                    user_id: this.currentUser.id,
                })
                .with(['from.user',
                    'from.customer',
                    'to.user',
                    'to.customer',
                    'transferring.user'])
                .orderBy('start_time', 'desc')
                .limit(6)
                .get()
                .then((response) => {
                    this.historyItems = response;
                    this.loading = false;
                });

        }
    },
    computed: {
        currentUser() {
            return User.loggedInUser();
        },
    },
    created() {
        this.getHistory();
    }
}
</script>
